var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { RestClient } from '@pegasus/rest-client';
import { getCSRFCookie } from '@browsing/utils';
var CSRF_HEADER = 'x-xsrf-token';
var XSRF = 'frsx_csrf';
export var getBestDeals = function (queryParams) {
    var _a;
    return RestClient.post("/api/phoenix/search/best-deals/articles")
        .withClientType('web')
        .withQueryParameters(__assign({ size: 16 }, queryParams))
        .withHeaders((_a = {
            'X-Touchpoint': 'best-deals'
        },
        _a[CSRF_HEADER] = getCSRFCookie(XSRF) || '',
        _a))
        .withRetry({ retries: 2 })
        .send()
        .then(function (req) { return req.json(); });
};
